import React from 'react'
import { motion } from "framer-motion";
import { images } from '../data/gallery';
import { MDBBtn, MDBIcon } from 'mdb-react-ui-kit';
import { useWebsiteContext } from '../context/website_context';

const GalleryContainer = () => {

  const { currentImg, galleryON, showHideGallery, changeImageGallery } = useWebsiteContext();

  return (
    <section className={`row m-0 d-flex align-items-center gallery-container section-full-frame ${galleryON ? '' : 'gallery-container-off'}`} onClick={showHideGallery}>
               <div className="w-100" style={{ position: 'absolute', right: '10px', top: '10px' }}>
                    <MDBBtn floating size='lg' className="p-3 d-flex justify-content-center align-items-center section-btn float-end" 
                           onClick={(event) => {
                               event.stopPropagation();
                               showHideGallery();
                           }}>
                               <MDBIcon fas icon="times" size='2x' className="icon-navigation"/>
                    </MDBBtn>
               </div>
            <div className="col-sm-12 d-flex flex-row justify-content-between align-items-center">
                <MDBBtn floating size='lg' className="p-3 d-none d-md-flex justify-content-center align-items-center gallery-container-btn section-btn"
                onClick={(event) => {
                    event.stopPropagation();
                    changeImageGallery('left');
                }}>
                    <MDBIcon fas icon="chevron-left" size='2x' className="icon-navigation"/>
                </MDBBtn>
                <motion.div initial={{ opacity: 0}} animate={{ opacity: 1 }} transition={{ duration: 2}}>
                    <img className="rounded-5 img-fluid gallery-container-img mt-3" loading="lazy" src={images[currentImg].imgURL} alt={images[currentImg].id} />
                </motion.div>
                <MDBBtn floating size='lg' className="p-3 d-none d-md-flex justify-content-center align-items-center gallery-container-btn section-btn" 
                onClick={(event) => {
                    event.stopPropagation();
                    changeImageGallery('right');
                }}>
                    <MDBIcon fas icon="chevron-right" size='2x' className="icon-navigation"/>
                </MDBBtn>
            </div>
      
    </section>
  )
}

export default GalleryContainer
